























































import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";
import {ConfiguredImageDto, DetailedImageRequirementDto, ImageDto, ImageRequirementDto, PersonDto} from "@swagger";
import ImageSelector from "@/components/product-configuration/ImageSelector.vue";
import {ImageRows} from "@/global/types";
import ImagePreview from "@/components/ImagePreview.vue";
import ManuallyExpandableImagePreview from "@/components/ManuallyExpandableImagePreview.vue";
import TypeEnum = ImageRequirementDto.TypeEnum;
import Vue from "vue";

@Component({
  components: {ManuallyExpandableImagePreview, ImagePreview, ImageSelector}
})
export default class MultipleRequirementsSelector extends BasicComponent {

  @Prop(Array) value: ConfiguredImageDto[][];
  @Prop(Array) requirements: DetailedImageRequirementDto[];
  @Prop(Boolean) detailedConfiguration: boolean;
  @Prop(Object) person: PersonDto;

  requirementIndex: number = 0; // The requirement which is currently being configured

  mounted() {
    setTimeout(() => { // Step expanded
      const imageSelector = this.$refs.imageSelector as ImageSelector;
      imageSelector.onContainerSizeChange();
    }, 1000);
  }

  getImages(requirement: ImageRequirementDto): ImageRows {
    const imageIds = new Set(this.person.imageIds);
    return this.$store.getters.imageSelection.images.filter((image: ImageDto) => imageIds.has(image.uniqueId) &&
        this.imageMatchesRequirement(image, requirement));
  }

  selectRequirement(index: number): void {
    this.requirementIndex = index;
  }

  onImageSelect(requirementIndex: number, images: ConfiguredImageDto | ConfiguredImageDto[]) {
    if (this.requirements[requirementIndex].requirement.type === TypeEnum.ALLOFPERSON) {
      this.$set(this.value, requirementIndex, images);
      return;
    }
    this.$set(this.value, requirementIndex, [images]);
  }

  getPreviewImage(index: number): ImageDto {
    const image = this.value[index][0];
    return this.$store.getters.imageById(image.uniqueImageId);
  }

  navigateToStep(index: number): void {
    this.requirementIndex = index;
    this.scrollToRequirements();
  }

  scrollToRequirements(): void {
    const ref = this.$refs["requirements"] as Vue;
    if (!ref) return;
    ref.$el.scrollIntoView({behavior: "smooth"});
  }

  navigateToNextStep(): void {
    if (this.configurationComplete) return;
    this.navigateToStep(this.nextStepIndex);
  }

  reset(): void {
    this.requirementIndex = 0;
  }

  get currentRequirement(): DetailedImageRequirementDto {
    return this.requirements[this.requirementIndex];
  }

  get firstUnsatisfiedRequirementIndex(): number {
    for (let i = 0; i < this.requirements.length; i++) {
      if (!this.isRequirementSatisfied(i)) return i;
    }
    return null;
  }

  get nextStepIndex(): number {
    if (this.requirementIndex < this.requirements.length - 1
        && this.requirements[this.requirementIndex + 1].requirement.type === TypeEnum.ALLOFPERSON) {
      return this.requirementIndex + 1;
    }
    return this.firstUnsatisfiedRequirementIndex;
  }

  get configurationComplete(): boolean {
    return this.firstUnsatisfiedRequirementIndex == null;
  }

  get currentRequirementSatisfied(): boolean {
    return this.isRequirementSatisfied(this.requirementIndex);
  }

  get currentRequirementNeedsAllImagesOfPerson(): boolean {
    return this.requirementNeedsAllImagesOfPerson(this.currentRequirement.requirement);
  }

  requirementNeedsAllImagesOfPerson(requirement: ImageRequirementDto): boolean {
    return requirement.type === TypeEnum.ALLOFPERSON;
  }

  isRequirementSatisfied(index: number): boolean {
    return this.value[index].length > 0;
  }

}

